'use client';
import React, { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';
import { Container } from '@shared';

import FooterProducts from './products';
import FooterCopyright from './copyright';
import FooterContent from './footerContent';
import FooterLinks from './footerLinks';
import {
  FooterContainer,
  Wrapper,
  FooterWrapper,
  LinkWrapper,
  FooterSeparator,
} from './styled';
import SocialMediaIcons from './socialMedia';

export interface IFooter {
  fullContent?: boolean;
  footerData: SFHeaderFooterCategoryFooterViewModel['footer'];
  categoryFooterData: SFHeaderFooterCategoryFooterViewModel['categoryFooter'];
}

const Footer: FC<IFooter> = ({
  fullContent,
  footerData,
  categoryFooterData,
}) => {
  const { xl: isDesktop } = useBreakpoint();

  return (
    <FooterContainer>
      <Container noPadding>
        {isDesktop ? (
          <>
            <Wrapper>
              <FooterWrapper>
                {fullContent && (
                  <>
                    <FooterProducts categoryFooterData={categoryFooterData} />
                    <FooterSeparator />
                  </>
                )}

                <FooterContent
                  corporateContent={footerData?.corporateContent || ' '}
                />
              </FooterWrapper>
              <LinkWrapper>
                <FooterLinks corporateLinks={footerData?.footerLinks || []} />
                <SocialMediaIcons footerIcons={footerData?.footerIcons || []} />
              </LinkWrapper>
            </Wrapper>

            <FooterSeparator />

            <FooterCopyright footerLogos={footerData?.footerLogos || []} />
          </>
        ) : (
          <>
            <Wrapper>
              <FooterWrapper>
                {fullContent && (
                  <>
                    <FooterProducts categoryFooterData={categoryFooterData} />
                    <FooterSeparator />
                  </>
                )}

                <FooterContent
                  corporateContent={footerData?.corporateContent || ' '}
                />
              </FooterWrapper>

              <FooterSeparator />

              <FooterCopyright footerLogos={footerData?.footerLogos || []} />
            </Wrapper>
            <LinkWrapper>
              <FooterLinks corporateLinks={footerData?.footerLinks || []} />
              <SocialMediaIcons footerIcons={footerData?.footerIcons || []} />
            </LinkWrapper>
          </>
        )}
      </Container>
    </FooterContainer>
  );
};
export default Footer;
